module.exports = __webpack_public_path__ + "img/solution_subsystem_06@2x.acf6111d.png";